// vCard download button — saves Talkani contact to phone's address book
import { Download, Check } from "lucide-react";
import { useState } from "react";
import { useLang } from "../contexts/LangContext";

const VCARD = `BEGIN:VCARD
VERSION:3.0
N:Talkani;Logistik & Reinigung GmbH i. Gr.;;;
FN:Talkani Logistik & Reinigung GmbH i. Gr.
ORG:Talkani Logistik & Reinigung GmbH i. Gr.
TITLE:Logistik · Reinigung · Service
TEL;TYPE=WORK,VOICE:+491758802646
TEL;TYPE=WORK,CELL:+491758802646
EMAIL;TYPE=WORK,INTERNET:info@talkani.de
URL:https://talkani.de
ADR;TYPE=WORK:;;Walddörferstraße 383;Hamburg;;22047;Deutschland
GEO:53.601989;10.135829
NOTE:Lieferung · Umzug · Reinigung · Regenrinnen · Winterdienst · E-Scooter Service. Wir sprechen Deutsch, English, Russian, Ukrainian, Arabic.
CATEGORIES:Logistik,Reinigung,Umzug,Service
END:VCARD`;

function download() {
  const blob = new Blob([VCARD], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "Talkani.vcf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 500);
}

export default function VCardButton({ variant = "inline" }) {
  const { t } = useLang();
  const ct = t.vcard;
  const [done, setDone] = useState(false);

  const handle = () => {
    download();
    setDone(true);
    setTimeout(() => setDone(false), 2500);
  };

  if (variant === "inline") {
    return (
      <button
        type="button"
        onClick={handle}
        className="inline-flex items-center gap-2 text-sm font-bold text-[#FF5A00] hover:text-[#E04F00] underline-offset-4 hover:underline transition"
        data-testid="vcard-download-btn"
      >
        {done ? <Check size={14} /> : <Download size={14} />}
        {done ? ct.saved : ct.save_contact}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handle}
      className="bg-white text-[#090A0B] hover:bg-neutral-200 font-bold tracking-wider uppercase text-xs px-5 py-3 inline-flex items-center gap-2 transition"
      data-testid="vcard-download-btn"
    >
      {done ? <Check size={14} /> : <Download size={14} />}
      {done ? ct.saved : ct.save_contact}
    </button>
  );
}
